// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2sZso","ranges":"BmiRanges_ranges__1PGzK"};